import React, { useEffect, useState } from "react";
import "./style.scss";
import DatePicker from "react-datepicker";
import { addDays, format } from "date-fns";
import "react-datepicker/dist/react-datepicker.css";
import TitleExpand from "../Expandtitle";
import CloseBtn from "../CloseBtn";
import { Select } from "antd";
import Storelist from "../../Store/Actions";
import Api from "../../Utils/Api";
import { RiCalendarScheduleFill } from "react-icons/ri";
import { toast } from "react-toastify";
const { Option } = Select;

const RescheduleModal = () => {
  const { GetAvailableTechnician, GetSlotTimes,RescheduleService } = Api();
  const {
    CreateRequestDetailsStore,
    setCreateRequestData_,
    setReschedule,
    ServiceDetailsStore,
    setAvailableTechnicianData_,
    setslotTime_,
  } = Storelist();console.log();
  const serviceDetail = ServiceDetailsStore?.data;
  const [selectedDate, setSelectedDate] = useState(null);
  const [slotBooked,setSlotBooked] = useState(null)

  useEffect(() => {
    const data = {};
    data.branchId = serviceDetail?.bikeRequest?.branch;
    data.serviceType = serviceDetail?.bikeRequest?.serviceType?._id;
    GetAvailableTechnician(data);

    return () => {
      setCreateRequestData_({ key: "technician", value: null });
      setCreateRequestData_({ key: "pickupPerson", value: null });
      setCreateRequestData_({ key: "dropPerson", value: null });
      setSelectedDate(null);
      setAvailableTechnicianData_(null);
      setSelectedDate(null);
      setslotTime_(null);
    };
  }, []);

  useEffect(() => {
    if (selectedDate) {
      setSlotBooked(null);
      const payload = {
        serviceType: serviceDetail?.bikeRequest?.serviceType?._id,
        branchId: serviceDetail?.bikeRequest?.branch,
        slotDate: format(selectedDate, "yyyy-MM-dd"),
      }
      if( serviceDetail?.bikeRequest?.city){
        payload.cityId = serviceDetail?.bikeRequest?.city
      }
      GetSlotTimes(payload);
    }
  }, [selectedDate]);

  const closeRescheduleTab = () => {
    setReschedule(false);
  };

  
  
  const submitReschedule =()=>{

    if(!slotBooked){
      toast.warn("Please select slot",{position:"top-center"})
      return
    }
    if(!selectedDate){
      toast.warn("Please select date",{position:"top-center"})
      return
    }

    console.log(slotBooked);

      const data = {};
      data.serviceId=serviceDetail?.bikeRequest?._id;
      data.slotBooked=slotBooked;
      RescheduleService(data)
  }

  return (
    <div className="Reschedule-container">
      <div className="w-[90%]">
        <CloseBtn color={"--dark"} closeHandler={closeRescheduleTab} />
      </div>
      <div className="title-container">
        <TitleExpand title={"Reschedule booking"} color={"--dark"} />
      </div>

      <div className="date-container border-container">
        <DatePicker
          selected={selectedDate}
          onChange={(date) => setSelectedDate(date)}
          minDate={addDays(new Date(), 0)} // today
          maxDate={addDays(new Date(), 90)} // today + 90 days
          dateFormat="dd/MM/yyyy"
          inline
          calendarClassName="custom-calendar"
        />
      </div>

      <div className="selected-reschedule-date border-container">
        {selectedDate
          ? format(selectedDate, "dd-MM-yyyy EEEE")
          : "Please select the Date for Reschedule"}
      </div>

      <div className="time-slot-container border-container">
        <Select
          id="SlotTime"
          name="slotTime"
          placeholder="Select your time slot"
          className="time-slot-dropdown"
          onChange={(value) => setSlotBooked(value)}
        >
          {CreateRequestDetailsStore?.slotTimeList
            ?.filter((opt) => opt?.status === 1) // only status 1
            .map((opt, index) => (
              <Option key={index} value={opt?.bookingDate}>
                {opt.slotTime}
              </Option>
            ))}
        </Select>
      </div>

      



      <div className="submit-btn-container ">
        <button className="service-modify-btn" onClick={submitReschedule}>
          <span><RiCalendarScheduleFill /></span> <span>Reschedule</span>
        </button>
      </div>
    </div>
  );
};

export default RescheduleModal;
